import { render, staticRenderFns } from "./simple-unit-table.vue?vue&type=template&id=1cfd3406&"
import script from "./simple-unit-table.vue?vue&type=script&lang=js&"
export * from "./simple-unit-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports